import { Controller } from "@hotwired/stimulus"

// Created by AI
// Handles dynamic add/remove for input params and potential future interactivity
export default class extends Controller {
  static targets = ["paramsContainer"]

  addParam(event) {
    event.preventDefault();
    const container = this.paramsContainerTarget;
    const row = document.createElement('div');
    row.className = 'input-param-row flex gap-2 mb-2';
    row.innerHTML = `
      <input type="text" name="prompt_eval[input_params_keys][]" placeholder="Parameter name" class="flex-1">
      <textarea name="prompt_eval[input_params_values][]" placeholder="Parameter value (Ruby object)" class="flex-2"></textarea>
      <button type="button" data-action="click->eval-conversion#removeParam" class="text-alert-red-600">Remove</button>
    `;
    container.appendChild(row);
  }

  removeParam(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const row = button.closest('.input-param-row');
    if (row) row.remove();
  }
}
